/**
 * Handles all focus to anchor
 * @module maskDate to
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import throttle from 'lodash/throttle';
import mergeOptions from '../lib/merge-options';
// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'fixedSidebar';
export const DEFAULTS = {

};



const applyEventListners = (el) => {
  const $el = $(el);
  const $header = $('.js-fixed-header');
  const $footer = $('.js-site-footer');
  const sidebarWidth = $el.outerWidth();
  let sidebarPagePos = $el.offset().top;
  let sibebarPosCaptured = false;
  const offsetTop = 10;
  const offsetBottom = 20;
  const $window = $(window);
  let sidebarFixed = false;

  $window.on('scroll.fixedSidebar resize.fixedSidebar',throttle(()=>{
    const footerTop = $footer.offset().top;
    const viewportTop = $window.scrollTop();
    const viewportBottom = viewportTop + $window.height();
    const headerHeight = $header.height();
    const headerIsFixed = $header.hasClass('is-fixed');
    if(headerIsFixed && !sibebarPosCaptured) {
      sidebarPagePos = $el.offset().top - offsetTop;
      sibebarPosCaptured = true;
    }
    /*

      Calculate header height to get header bottom position.
      Statement is true when scroll bar top position meets the bottom header.
      Then side bar will be fixed.

     */
    if((viewportTop + headerHeight) >= sidebarPagePos && !sidebarFixed) {
      sidebarFixed = true;
      $el.addClass('fixed-sidebar').css({top: `${headerHeight + offsetTop}px`, width: sidebarWidth, height: `calc(100vh - ${headerHeight}px)`});
    }
    if(sidebarFixed) {
      /*
        When the viewport scroll position meets the scroll position of the scroll bar and height
      */
      if((viewportTop + headerHeight) <= sidebarPagePos ) {
        $el.removeClass('fixed-sidebar').css({top: '', width: '', height: ''});
        sidebarFixed = false;
      }
      /*
        When footer is visible inside the viewport
      */
      if (viewportBottom >= footerTop) {
        const footerVisibleHeight = viewportBottom - footerTop;
        $el.css({height:`calc(100vh - ${headerHeight+footerVisibleHeight+offsetBottom}px)`});
      }
    }
  },10));
  $el.on('mouseenter', ()=> {
    $el.focus();
  })
}
const wrapSidebar = ($el) => {
  $el.wrapInner('<div class="fixed-sidebar__wrap"></div>');
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function fixedSidebar(el, options = {}, { deregister }) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventListners(el);
  wrapSidebar($el);

}

registerJQueryPlugin(PLUGIN_NAME, fixedSidebar);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-sidebar.js